import React from "react"

interface IPropsEditIcon {
  className?: string
  smallSizeIcon?: boolean
  onClick?: () => void
}

const EditIcon = ({ className, smallSizeIcon, onClick }: IPropsEditIcon) =>
  smallSizeIcon ? (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M9.00008 2.99996L11.0001 4.99996M7.66675 12.3333H13.0001M2.33341 9.66663L1.66675 12.3333L4.33341 11.6666L12.0574 3.94263C12.3074 3.69259 12.4478 3.35351 12.4478 2.99996C12.4478 2.64641 12.3074 2.30733 12.0574 2.05729L11.9427 1.94263C11.6927 1.69267 11.3536 1.55225 11.0001 1.55225C10.6465 1.55225 10.3075 1.69267 10.0574 1.94263L2.33341 9.66663Z"
        stroke="#757575"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M12 2.99994L15 5.99994M10 16.9999H18M2 12.9999L1 16.9999L5 15.9999L16.586 4.41394C16.9609 4.03889 17.1716 3.53027 17.1716 2.99994C17.1716 2.46961 16.9609 1.961 16.586 1.58594L16.414 1.41394C16.0389 1.039 15.5303 0.828369 15 0.828369C14.4697 0.828369 13.9611 1.039 13.586 1.41394L2 12.9999Z"
        stroke="#757575"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )

export default EditIcon
